const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  items: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1
};
export const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_COMMENTS`: {
      return initialState;
    }

    case `FETCH_COMMENTS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_COMMENTS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case `FETCH_COMMENTS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case `SAVE_COMMENT_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_COMMENT_FULFILLED`: {
      const { data } = action.payload.data;

      const object = state.items.find(item => item.id === data.id);
      if (!object) {
        const a = [data, ...state.items];
        const o2 = a.sort((a, b) => {
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        });
        return {
          ...state,
          saving: false,
          saved: true,
          items: o2,
          nbResult: state.nbResult + 1
        };
      }

      const newObj = { ...object, ...data };
      const newObjs = state.items.map(item => {
        return item.id === newObj.id ? newObj : item;
      });

      const o2 = newObjs.sort((a, b) => {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      });

      return {
        ...state,
        items: o2
      };
    }
    case `SAVE_COMMENT_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        saved: false,
        error
      };
    }

    case `FETCH_INFINITE_COMMENTS_PENDING`: {
      return { ...state, fetched: false, fetching: true };
    }
    case `FETCH_INFINITE_COMMENTS_FULFILLED`: {
      const { data, nbResult } = action.payload.data;

      // Ovoid duplicates
      const newItems = (data || []).filter(newItem => {
        return !state.items.find(item => item.id === newItem.id);
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: state.items.concat(newItems),
        nbResult: nbResult
      };
    }
    case `FETCH_INFINITE_COMMENTS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/comment.js